import usePopup from '@hooks/usePopup';
import { FiMenu } from 'react-icons/fi';
import NavMenuDrawer from '../popups/nav-menu.drawer';

export default function HambergerMenu() {
  const { openPopup } = usePopup();

  const handleMenuClick = () => {
    openPopup({
      isOpen: true,
      type: 'drawer',
      Component: NavMenuDrawer,
      props: {},
      isBackClose: true,
      popupOptions: { size: 'xs', placement: 'left' },
    });
  };
  return (
    <button type="button" onClick={handleMenuClick}>
      <FiMenu size="24" />
    </button>
  );
}
